// extracted by mini-css-extract-plugin
export default {"styles":"Congratulations_styles__chKM1"};